var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var searchWrapper = {
    background: '#f5f9fc',
    borderBottom: '1px solid #c9cfd4',
    borderTop: '1px solid #c9cfd4',
    padding: "".concat(16, "px ").concat(32, "px"),
};
export var searchWrapperTopBorderOnly = __assign(__assign({}, searchWrapper), { borderBottom: 0 });
export var searchWrapperBottomBorderOnly = __assign(__assign({}, searchWrapper), { borderTop: 0 });
export var iconColor04 = '#323E48';
